import linegraph from '../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import { domainName } from "../../../../utility/index"

export default {
    data() {
        return {
            costOption: {},
            costLoading: false,
            optionPie: {},
            pieLoading: false,
            orgId: '',
            isValue: true,
            isShow: true,
            formInline: {
                carId: '',
            },
            height: '500',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('MaintenanceAnalysis.carId'),
                    align: "center",
                },
                {
                    prop: "orgName",
                    label: this.$t('MaintenanceAnalysis.orgName'),
                    align: "center",

                },
                {
                    prop: "maintainCount",
                    label: this.$t('MaintenanceAnalysis.maintainCount'),
                    align: "center",
                },
                {
                    prop: "maintainPeopleCost",
                    label: this.$t('MaintenanceAnalysis.maintainPeopleCost'),
                    align: "center",
                },
                {
                    prop: "maintainMaterialCost",
                    label: this.$t('MaintenanceAnalysis.maintainMaterialCost'),
                    align: "center",
                },
                {
                    prop: "repairCount",
                    label: this.$t('MaintenanceAnalysis.repairCount'),
                    align: "center",
                },
                {
                    prop: "repairPeopleCost",
                    label: this.$t('MaintenanceAnalysis.repairPeopleCost'),
                    align: "center",
                },
                {
                    prop: "repairMaterialCost",
                    label: this.$t('MaintenanceAnalysis.repairMaterialCost'),
                    align: "center",
                },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    methods: {
        queryMaintainCost() {
            this.pieLoading = true
            let param = {
                orgId: this.orgId,
            };
            this.$store.dispatch('MaintenanceAnalysis/GET_SELECTCOSTRATE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        let maintainRate = res.data.data.maintainRate == undefined ? 0 : res.data.data.maintainRate.replace('%', '')
                        let repairRate = res.data.data.repairRate == undefined ? 0 : res.data.data.repairRate.replace('%', '')
                        this.FaultPie(maintainRate, repairRate)
                    }
                }
                this.pieLoading = false
            }).catch(err => {
                this.pieLoading = false
            })
        },
        FaultPie(maintainRate, repairRate) {
            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: "{b} : {c} ({d}%)"
                },
                legend: {
                    left: 'center',
                    data: [this.$t('MaintenanceAnalysis.repairCostRate'), this.$t('MaintenanceAnalysis.maintainCostRate')],
                    top: '10',
                    itemWidth: 15, 
                    itemHeight: 15, 
                    textStyle: {
                        color: '#fff'
                    }
                },
                series: [
                    {
                        name: this.$t('common.number'),
                        type: 'pie',
                        radius: ['45%', '65%'],
                        center: ['50%', '60%'],
                        label: {
                            formatter: '{b}\n{d}% ',
                        },
                        data: [
                            { value: maintainRate, name: this.$t('MaintenanceAnalysis.repairCostRate') },
                            { value: repairRate, name: this.$t('MaintenanceAnalysis.maintainCostRate') },
                        ],
                        label: {
                            color: '#fff'
                        },
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    var colorList = [
                                        ['#fc5a62', '#f69d70'],
                                        ['#56d1a9', '#baeb46'],
                                    ];
                                    return new echarts.graphic.LinearGradient(0, 0, 0, 1,

                                        [
                                            { offset: 0, color: colorList[params.dataIndex][0] },
                                            { offset: 1, color: colorList[params.dataIndex][1] }
                                        ]);
                                },
                            }

                        }
                    }
                ]
            }
            this.optionPie = option
        },

        maintainCostCompare() {
            this.costLoading = true
            let obj = {
                Data: [],
                YearCost: [],
                LastYearCost: [],
                YearRate: [],
                MonthRate: [],
            }
            let param = {
                orgId: this.orgId,
            }
            this.$store.dispatch("MaintenanceAnalysis/GET_SELECTCOSTCOMPARE", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        res.data.data.map((item, index) => {
                            obj.Data.push(item.statisticsMonth)
                            obj.YearCost.push(item.currentYearTotalCost)
                            obj.LastYearCost.push(item.lastYearTotalCost)
                            obj.YearRate.push(item.yearRate == null ? 0 : item.yearRate.replace('%', ''))
                            obj.MonthRate.push(item.monthRate == null ? 0 : item.monthRate.replace('%', ''))
                            this.costCompare(obj)
                        })
                    }
                }
                this.costLoading = false
            }).catch(err => {
                this.costLoading = false
            })
        },
        costCompare(costData) {
            let option = {
                tooltip: {
                    trigger: 'axis',
                    formatter: function (param) {
                        let colorBlue = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${param[2].color.colorStops[0].color};"></span>`
                        let colorZi = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${param[3].color.colorStops[0].color}"></span>`
                        let html = ''
                        html += param[0].axisValue + '<br/>' + param[0].marker + param[0].seriesName + ':' + param[0].value + '%' + '<br/>'
                        html += param[1].marker + param[1].seriesName + ':' + param[1].value + '%' + '<br/>'
                        html += colorBlue + param[2].seriesName + ':' + param[2].value + this.$t('MaintenanceAnalysis.yuan') + '<br/>'
                        html += colorZi + param[3].seriesName + ':' + param[3].value + this.$t('MaintenanceAnalysis.yuan') + '<br/>'
                        return html
                    }
                },
                legend: {
                    left: '100',
                    data: [this.$t('MaintenanceAnalysis.lastYearMaintainCost'), this.$t('MaintenanceAnalysis.thisYearMaintainCost'), this.$t('MaintenanceAnalysis.yearOnYearGrowthRate'), this.$t('MaintenanceAnalysis.monthOnMonthGrowthRate')],
                    top: '10',
                    itemWidth: 15, 
                    itemHeight: 15, 
                    textStyle: {
                        color: '#fff'
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff',
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#fff',

                        }
                    },
                    splitLine: { show: false },
                    data: costData.Data
                },
                grid: {
                    left: '1%',
                    right: '1%',
                    bottom: '2%',
                    containLabel: true
                },
                yAxis: [{
                    type: 'value',
                    name: this.$t('MaintenanceAnalysis.riseRate'),
                    nameTextStyle: {
                        color: "white",
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['rgba(173,177,195,.1)'],
                            type: 'dashed'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    min: 0,
                    max: 100,
                    interval: 20,
                    axisLabel: {
                        formatter: '{value} %',
                        color: '#fff'
                    }
                }, {
                    type: 'value',
                    name: this.$t('MaintenanceAnalysis.moneyYuan'),
                    nameTextStyle: {
                        color: "white",
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        color: '#fff'
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['rgba(173,177,195,.1)'],
                            type: 'dashed'
                        }
                    },
                }],
                series: [
                    {
                        name: this.$t('MaintenanceAnalysis.yearOnYearGrowthRate'),
                        type: 'line',
                        smooth: true,
                        data: costData.YearRate,
                        color: '#f33a3a',
                    },
                    {
                        name: this.$t('MaintenanceAnalysis.monthOnMonthGrowthRate'),
                        type: 'line',
                        smooth: true,
                        data: costData.MonthRate,
                        color: '#fec055'
                    },
                    {
                        name: this.$t('MaintenanceAnalysis.lastYearMaintainCost'),
                        yAxisIndex: 1,
                        data: costData.LastYearCost,
                        type: 'bar',
                        barCategoryGap: '40%',
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#16e1ff' },
                                        { offset: 1, color: '#1ee2ff' },
                                    ]
                                )
                            },
                        }
                    },
                    {
                        name: this.$t('MaintenanceAnalysis.thisYearMaintainCost'),
                        yAxisIndex: 1,
                        data: costData.YearCost,
                        type: 'bar',
                        barCategoryGap: '40%',
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#007cfc' },                   
                                        { offset: 1, color: '#409eff' },                   
                                    ]
                                )
                            },
                        }
                    },
                ]
            }
            this.costOption = option
        },

        getMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectTimeType: 2,
                carId: this.formInline.carId
            };
            this.$store.dispatch('MaintenanceAnalysis/GET_SELECTCOSTLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getMonthOrderList()
        },
        onClear() {
            this.formInline.carId = ''
            this.getMonthOrderList()
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}//getCameraListExcel/exportCostList?orgId=${this.orgId}&selectTimeType=${2}&carId=${this.formInline.carId}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}//getCameraListExcel/exportCostList?orgId=${this.orgId}&selectTimeType=${2}&carId=${this.formInline.carId}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getMonthOrderList();
        },
    }
}
